import React, { Component, createContext } from 'react';
import jwtDecode from 'jwt-decode';
import userAxios from '../shared/user-axios';
import adminAxios from '../shared/admin-axios';

export const LoginContext = createContext({});

export const USER_TOKEN_NAME = 'user_token';

export const ADMIN_TOKEN_NAME = 'admin_token';

class LoginContextProvider extends Component {
  // State
  constructor(props) {
    super(props);

    const userToken = localStorage.getItem(USER_TOKEN_NAME);
    const adminToken = localStorage.getItem(ADMIN_TOKEN_NAME);

    this.state = {
      userToken,
      adminToken,
      maxAdminAccounts: 2,

      agency_number: '',
      username: '',
      password: '',
      isLoading: false,
      count: 0,
      toggleMenu: false,
      ageasFont: 'normalFont',

      // Agencies
      agencies: [],
      agenciesCount: 0,
      agencyManagement: {
        page: 1,
        search_agency_name: '',
        search_agency_number: '',
      },

      // BROKER
      firstname: '',
      lastname: '',
      email: '',
      status: '',
      userArr: [],
      activePage: 1,
      totalCount: 0,
      itemPerPage: 20,
      showModal: false,
      closeModal: false,

      agencyId: 0,
      userDetails: {},
      adminBroker: [],

      activeAdminArr: [],

      emailTemplates: [],
      emailTemplateCount: 0,
      emailTemplatePage: 0,
      emailTemplateDetails: [],

      onlineContentTemplates: [],
      onlineContentCount: 0,
      onlineContentPage: 0,
      onlineContentDetails: [],

      brokenLinks: [],
      brokenLinksCount: 0,
      brokenLinksPage: 0,

      broker: [],
      brokerCount: 0,
      flagId: 0,
      flagIdAdmin: 0,

      selectedId: 0,
      modalType: '',

      showModalLoader: false,

      selectStatus: [
        { id: '1', name: 'Active' },
        { id: '2', name: 'Inactive' },
        { id: '3', name: 'Pending' },
        { id: '4', name: 'Delete' },
        { id: '5', name: 'Lockout' },
      ],
      pendingStatus: [
        { id: '1', name: 'Active' },
        { id: '2', name: 'Inactive' },
        { id: '3', name: 'Pending' },
        { id: '4', name: 'Delete' },
        { id: '5', name: 'Lockout' },
      ],

      CMS_users: [],
      CMS_count: 0,
      CMS_id: 0,
      CMS_userDetails: [],
      CMS_isCheckedEmail: false,
      CMS_isCheckedUser: false,
      CMS_UserType: [
        { id: '1', name: 'CMS Full Access' },
        { id: '2', name: 'CMS Broker Access' },
        { id: '3', name: 'CMS Limited Access' },
      ],
      CMS_SelectStatus: [
        { id: '0', name: 'Blocked' },
        { id: '1', name: 'Active' },
      ],

      isChecked: false,
      isCheckedActive: false,

      selectUserType: [
        { id: '0', name: 'Administrator' },
        { id: '1', name: 'User' },
      ],
      modalToShow: null,
      setPass: 0,
      ...props.initialState,
    };
  }

  componentDidMount() {
    userAxios.interceptors.request.use(
      (config) => {
        // Insert authorization token on request call
        const { userToken } = this.state;

        config.headers.Authorization = `Bearer ${userToken}`;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    userAxios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (!error.response) {
          this.clearUserToken();
          return Promise.reject(error);
        }
        if (error.response.status === 401) {
          this.clearUserToken();
        }
        return Promise.reject(error.response);
      },
    );

    // Add a request interceptor
    adminAxios.interceptors.request.use(
      (config) => {
        // Insert authorization token on request call
        const { adminToken } = this.state;

        config.headers.Authorization = `Bearer ${adminToken}`;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    // Add a response interceptor
    adminAxios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (!error.response) {
          this.clearAdminToken();
          return Promise.reject(error);
        }
        if (error.response.status === 401) {
          this.clearAdminToken();
          // window.location.href = '/changeControl';
        }
        return Promise.reject(error.response);
      },
    );
  }

  // Update User Credential State on Login
  getLoginDetails = (values) => {
    this.setState({
      agency_number: values.agency_number,
      username: values.username,
      password: values.password,
    });
  };

  updateIsLoading = (value) => {
    this.setState({
      isLoading: value,
    });
  };

  // HEADER
  updateFontSize = (value) => {
    this.setState({
      ageasFont: value,
    });
  };

  // BROKER
  UpdateBrokerDetails = (values) => {
    this.setState({
      firstname: values.newFirstname,
      lastname: values.newLastname,
      email: values.newEmail,
      status: values.newStatus,
    });
  };

  UpdateUserList = (values, page) => {
    let newState = {
      adminBroker: values.adminBroker,
      broker: values.broker,
      countAll: values.countBroker,
      brokerCount: values.countBroker,
      isLoading: false,
    };

    if (page !== undefined) {
      newState = { ...newState, activePage: page };
    }

    this.setState(newState);
  };

  UpdatePageChange = (value) => {
    this.setState({
      activePage: value.pageNumber,
    });
  };

  updateShowModalLoader = (value) => {
    this.setState({
      showModalLoader: value,
    });
  };

  updateEditAdministrator = (values) => {
    this.setState({
      userDetails: values.data,
      flagIdAdmin: values.id,
      isLoading: false,
    });
  };

  updateEditAgencyAdmin = (id, values) => {
    this.setState({
      userDetails: values,
      flagIdAdmin: id,
      isChecked: values.set_pass,
      isCheckedActive: values.set_active,
      isLoading: false,
    });
  };

  updateEditAgencyBroker = (id, values = {}) => {
    this.setState({
      userDetails: values,
      isChecked: values.set_pass,
      isCheckedActive: values.set_active,
      flagId: id,
      isLoading: false,
    });
  };

  updateUserBrokerList = (values) => {
    this.setState({
      userDetails: values,
      isLoading: false,
      showModal: false,
    });
  };

  updateAgencyList = (values, agencyNumber, agencyName, page) => {
    this.setState({
      agencies: values.data,
      agenciesCount: values.countUser,
      agencyManagement: {
        page,
        search_agency_number: agencyNumber,
        search_agency_name: agencyName,
      },
      isLoading: false,
    });
  };

  updateAgencyBrokerList = (id, values) => {
    const admResult = values.adminBroker.filter((word) => word.status === 1);

    this.setState({
      agencyId: id,
      adminBroker: admResult,
      activeAdminArr: admResult,
      broker: values.broker,
      countBroker: values.countBroker,
      brokerCount: values.countBroker,
      isLoading: false,
      showModal: false,
    });
  };

  updateAdminBrokerList = (values) => {
    this.setState({
      adminBroker: values,
      flagIdAdmin: values[0].id,
      isLoading: false,
    });
  };

  updateAdminBroker = (value) => {
    this.setState({
      adminBroker: value,
      broker: value,
    });
  };

  hideModal = () => {
    this.setState({
      isLoading: false,
      showModal: false,
      modalToShow: null,
    });
  };

  toggleIsChecked = () => {
    this.setState({ isChecked: !this.state.isChecked });
  };

  toggleIsCheckedActive = () => {
    this.setState({ isCheckedActive: !this.state.isCheckedActive });
  };

  //----------------------------------------------
  /**
   * Start of CMS Section
   */

  showCMSPermissionsModal = (values) => {
    this.setState({
      CMS_userDetails: values,
      CMS_id: values.id,
      CMS_isLoading: false,
      CMS_showModalPerm: true,
      CMS_isCheckedUser: values.check_user === 1,
      CMS_isCheckedEmail: values.check_email === 1,
    });
  };

  showCMSUserModal = (values) => {
    this.setState({
      CMS_userDetails: values,
      CMS_id: values.id,
      CMS_isLoading: false,
      CMS_showModal: true,
      CMS_isCheckedUser: values.check_user === 1,
      CMS_isCheckedEmail: values.check_email === 1,
    });
  };

  updateCMSUsersList = (values, page) => {
    let newState = {
      CMS_users: values.data,
      CMS_count: values.countUser,
      CMS_isLoading: false,
    };

    if (page !== undefined) {
      newState = { ...newState, activePage: page };
    }

    this.setState(newState);
  };

  toggleIsCheckedUser = () => {
    this.setState({ CMS_isCheckedUser: !this.state.CMS_isCheckedUser });
  };

  toggleIsCheckedEmail = () => {
    this.setState({ CMS_isCheckedEmail: !this.state.CMS_isCheckedEmail });
  };

  updateUserAdmin = (value) => {
    this.setState({
      path_name: value,
    });
  };

  updateShowModal = (value) => {
    this.setState({
      showModal: value,
    });
  };

  updateUserFlags = () => {
    this.setState({
      showModalLoader: false,
      isChecked: false,
      isCheckedActive: false,
    });
  };

  /*
   * EMAIL Content
   */
  updateEmailTemplatesList = (values, page) => {
    this.setState({
      emailTemplates: values.emailTemplate,
      emailTemplateCount: values.countEmailTemplate,
      emailTemplatePage: page,
    });
  };

  updateEmailTemplate = (values) => {
    this.setState({
      emailTemplateDetails: values.data,
      emailId: values.id,
      emailIsLoading: false,
    });
  };

  /*
   * Online Content
   */
  updateOnlineContentList = (values, page) => {
    this.setState({
      onlineContentTemplates: values.serviceTemplate,
      onlineContentCount: values.countServiceTemplate,
      onlineContentPage: page,
    });
  };

  updateOnlineContentTemplate = (values) => {
    this.setState({
      onlineContentDetails: values.data,
      onlineContentId: values.id,
      onlineContentIsLoading: false,
    });
  };

  /** Broken Links Report
   */

  updateBrokenLinksList = (values, page) => {
    this.setState({
      brokenLinks: values.data,
      brokenLinksCount: values.countBrokenLinks,
      brokenLinksPage: page,
    });
  };

  updateExtranetTandC = (value) => {
    this.setState({
      userDetails: value,
      isLoading: false,
    });
  };

  updateChangePassword = (values) => {
    this.setState({
      userDetails: values,
      isLoading: false,
      setPass: values.set_pass,
    });
  };

  updateCount = (values) => {
    this.setState({
      count: values,
    });
  };

  updateSelectedId = (id, modalType, modalMode = 'EDIT') => {
    this.setState({
      showModal: true,
      selectedId: id,
      userDetails: [],
      onlineContentDetails: [],
      emailTemplateDetails: [],
      modalType,
      modalMode,
    });
  };

  clearTokens = () => {
    this.clearUserToken();
    this.clearAdminToken();
  };

  setUserToken = (userToken) => {
    localStorage.setItem(USER_TOKEN_NAME, userToken);
    this.setState({
      userToken,
    });
  };

  clearUserToken = () => {
    if (this.state.userToken) {
      localStorage.removeItem(USER_TOKEN_NAME);
      this.setState({ userToken: undefined });
    }
  };

  setAdminToken = (adminToken) => {
    localStorage.setItem(ADMIN_TOKEN_NAME, adminToken);
    this.setState({
      adminToken,
    });
  };

  clearAdminToken = () => {
    if (this.state.adminToken) {
      localStorage.removeItem(ADMIN_TOKEN_NAME);
      this.setState({ adminToken: undefined });
    }
  };

  getTokenField = (token, fieldName) => {
    try {
      if (token) {
        const tokenData = jwtDecode(token);
        return tokenData[fieldName];
      }
      return undefined;
    } catch (error) {
      console.error(`Error getting ${fieldName} from token ${token}`, error);
      this.clearTokens();
    }
  };

  getAdminName = (token) => {
    return this.getTokenField(token, 'username');
  };

  getSuperAdmin = (token) => {
    return this.getTokenField(token, 'super_admin');
  };

  getUserType = (token) => {
    return this.getTokenField(token, 'user_type');
  };

  getCheckEmail = (token) => {
    return this.getTokenField(token, 'check_email');
  };

  getCheckUser = (token) => {
    return this.getTokenField(token, 'check_user');
  };

  getIsActive = (token) => {
    return this.getTokenField(token, 'set_pass');
  };

  getBrokerType = (token) => {
    return this.getTokenField(token, 'broker_type');
  };

  getPackageType = (token) => {
    return this.getTokenField(token, 'package_number');
  };

  getAgencyNumber = (token) => {
    return this.getTokenField(token, 'agency_number');
  };

  // Provider
  render() {
    return (
      <LoginContext.Provider
        value={{
          ...this.state,
          getLoginDetails: this.getLoginDetails,
          updateIsLoading: this.updateIsLoading,
          updateFontSize: this.updateFontSize,
          UpdateBrokerDetails: this.UpdateBrokerDetails,
          UpdateUserList: this.UpdateUserList,
          UpdatePageChange: this.UpdatePageChange,
          updateEditAdministrator: this.updateEditAdministrator,
          updateUserBrokerList: this.updateUserBrokerList,
          updateAdminBrokerList: this.updateAdminBrokerList,
          updateEditAgencyAdmin: this.updateEditAgencyAdmin,
          updateEditAgencyBroker: this.updateEditAgencyBroker,
          hideModal: this.hideModal,
          updateAgencyBrokerList: this.updateAgencyBrokerList,
          toggleIsChecked: this.toggleIsChecked,
          toggleIsCheckedActive: this.toggleIsCheckedActive,
          updateAgencyList: this.updateAgencyList,
          showCMSUserModal: this.showCMSUserModal,
          showCMSPermissionsModal: this.showCMSPermissionsModal,
          toggleIsCheckedUser: this.toggleIsCheckedUser,
          toggleIsCheckedEmail: this.toggleIsCheckedEmail,
          updateCMSUsersList: this.updateCMSUsersList,
          updateAdminBroker: this.updateAdminBroker,
          updateUserFlags: this.updateUserFlags,
          updateEmailTemplatesList: this.updateEmailTemplatesList,
          updateEmailTemplate: this.updateEmailTemplate,
          updateOnlineContentList: this.updateOnlineContentList,
          updateOnlineContentTemplate: this.updateOnlineContentTemplate,
          updateBrokenLinksList: this.updateBrokenLinksList,
          updateUserAdmin: this.updateUserAdmin,
          updateShowModalLoader: this.updateShowModalLoader,
          updateShowModal: this.updateShowModal,
          updateExtranetTandC: this.updateExtranetTandC,
          updateChangePassword: this.updateChangePassword,
          updateCount: this.updateCount,
          updateSelectedId: this.updateSelectedId,
          setAdminToken: this.setAdminToken,
          clearAdminToken: this.clearAdminToken,
          setUserToken: this.setUserToken,
          clearUserToken: this.clearUserToken,
          getAdminName: this.getAdminName,
          getSuperAdmin: this.getSuperAdmin,
          getUserType: this.getUserType,
          getCheckEmail: this.getCheckEmail,
          getCheckUser: this.getCheckUser,
          getIsActive: this.getIsActive,
          getBrokerType: this.getBrokerType,
          getPackageType: this.getPackageType,
          getAgencyNumber: this.getAgencyNumber,
        }}
      >
        {this.props.children}
      </LoginContext.Provider>
    );
  }
}

export default LoginContextProvider;
